<template>
  <v-app>
    <v-navigation-drawer rail permanent :border="false">
      <v-list density="compact" nav>
        <v-tooltip>
          {{ $t('LAYOUTS.DASHBOARD') }}
          <template v-slot:activator="{ props }">
            <v-list-item
              class="scope"
              v-bind="props"
              value="dashboard"
              @click="selectItem('dashboard')"
            >
              <v-icon icon="mdi-home-variant" />
            </v-list-item>
          </template>
        </v-tooltip>
        <v-tooltip>
          {{ $t('LAYOUTS.FOLDER') }}
          <template v-slot:activator="{ props }">
            <v-list-item
              class="scope"
              v-bind="props"
              value="folder"
              @click="selectItem('folder')"
              v-if="checkPermission(['DISTRIBUTOR_VIEW_REPAIR_FILE'])"
            >
              <v-icon icon="mdi-tag-outline" />
            </v-list-item>
          </template>
        </v-tooltip>
        <v-tooltip>
          {{ $t('LAYOUTS.ACCOUNTS') }}
          <template v-slot:activator="{ props }">
            <v-list-item
              class="scope"
              v-bind="props"
              value="accounts"
              @click="selectItem('accounts')"
              v-if="checkPermission(['DISTRIBUTOR_ACCOUNT_READ_PERMISSION'])"
            >
              <v-icon icon="mdi-account-group" />
            </v-list-item>
          </template>
        </v-tooltip>
        <v-tooltip>
          {{ $t('LAYOUTS.TRANSPORTER') }}
          <template v-slot:activator="{ props }">
            <v-list-item
              class="scope"
              v-bind="props"
              value="transporter"
              @click="selectItem('transporter')"
              v-if="checkPermission(['DISTRIBUTOR_TRANSPORTER_READ_PERMISSION'])"
            >
              <v-icon icon="mdi-truck-outline" />
            </v-list-item>
          </template>
        </v-tooltip>
        <v-tooltip>
          {{ $t('LAYOUTS.RECYCLING_REPORT') }}
          <template v-slot:activator="{ props }">
            <v-list-item
              class="scope"
              v-bind="props"
              value="recyclingReport"
              @click="selectItem('recyclingReport')"
            >
              <v-img class="specific-icon recycling-report" />
            </v-list-item>
          </template>
        </v-tooltip>
      </v-list>
      <template v-slot:append>
        <div class="line-top" />
        <v-list density="compact" nav>
          <v-tooltip>
            {{ $t('LAYOUTS.HELP') }}
            <template v-slot:activator="{ props }">
              <v-list-item class="scope" v-bind="props" value="help" @click="selectItem('help')">
                <v-icon icon="mdi-account-question-outline" />
              </v-list-item>
            </template>
          </v-tooltip>
        </v-list>
        <div class="line-bottom" />
        <v-list density="compact" nav>
          <v-tooltip>
            {{ $t('LAYOUTS.LOGOUT') }}
            <template v-slot:activator="{ props }">
              <v-list-item class="scope" v-bind="props" @click="logout()" value="exit">
                <v-icon icon="mdi-exit-to-app" />
              </v-list-item>
            </template>
          </v-tooltip>
        </v-list>
      </template>
    </v-navigation-drawer>

    <v-app-bar>
      <template class="logo-div">
        <v-img v-if="logo" alt="logo Network" class="logo" :src="logo" />
        <img v-if="!logo" alt="logo Boomerang" class="logo"
        src=@/assets/images/boomerang_black_logo.png>
      </template>
      <template v-if="displayStoreInfo">
        <p class="store-name">
          {{ repairFileStoreSelected() }}
        </p>
      </template>

      <v-spacer />

      <template v-if="displayCollaboratorInfo">
        <div class="mr-4 d-flex flex-row ga-1">
          <NotificationBell />

          <v-tooltip location="bottom">
            {{ $t('LAYOUTS.PROFILE') }}
            <template v-slot:activator="{ props }">
              <v-btn
                class="nav-btn"
                icon
                v-bind="props"
                @click="selectItem('profile')"
                v-bind:style="{ backgroundColor: profileActive ? activeColor : defaultColor }"
              >
                <v-icon
                  icon="mdi-account-outline"
                  :style="{ color: profileActive ? 'white' : '#165039' }"
                />
              </v-btn>
            </template>
          </v-tooltip>
        </div>

        <button
          ref="selectedCollaborator"
          class="selected-collaborator"
          type="button"
          @click="showCollaborators = !showCollaborators"
          :disabled="hideCollaboratorMenu"
        >
          <span class="d-flex flex-column align-start">
            <span class="selected-collaborator-name">
              {{ currentCollaborator.firstname + ' ' + currentCollaborator.lastname }}
            </span>
            <span class="selected-collaborator-email">{{ getEmailFromAccount() }}</span>
          </span>
          <v-icon
            v-if="!hideCollaboratorMenu"
            :icon="showCollaborators ? 'mdi-chevron-down' : 'mdi-chevron-up'"
          />
        </button>
      </template>
    </v-app-bar>

    <!--Collaborator list-->
    <div
      ref="collaboratorsList"
      class="collaborators-list"
      v-if="showCollaborators"
      :style="{ minWidth: minWidth }"
    >
      <ul>
        <li
          v-for="collaborator of getCollaboratorListActive"
          :key="collaborator.technical_id"
          :class="{ active: getActiveCollaborator(collaborator.technical_id) }"
          @click="selectCollaborator(collaborator)"
        >
          {{ collaborator.firstname + ' ' + collaborator.lastname }}
          <v-icon v-if="getActiveCollaborator(collaborator.technical_id)" icon="mdi-check" />
        </li>
      </ul>
    </div>
    <!--END Collaborator list-->

    <v-main class="main">
      <slot />
    </v-main>
  </v-app>
</template>

<script>
import { displayToast, handleResponseError } from '@/components/utils/globalFunction'
import { auth as $store } from '@/store/AuthModule'
import NotificationBell from '@/components/header/NotificationBell.vue'

export default {
  name: 'DistributorLayout',
  components: { NotificationBell },
  data() {
    return {
      currentCollaborator: this.getCurrentCollaborator(),
      selectedItem: 'dashboard',
      hoverHouse: false,
      hoverTicket: false,
      hoverEnergy: false,
      hoverGraphic: false,
      hoverPapers: false,
      hoverUser: false,
      hoverHelp: false,
      hoverTools: false,
      hoverExit: false,
      hoverProfile: false,
      showCollaborators: false,
      minWidth: '0px',
      zendeskUrl: import.meta.env.VITE_ZENDESK_URL,
      profileActive: false,
      defaultColor: '#FFFFFF!important',
      activeColor: '#559A1B!important',

      logo: null
    }
  },
  watch: {
    $route: {
      handler: function (params) {
        const foundRoute = this.$router.options.routes.find((route) => {
          return route.path.split('/')[1] === params.path.split('/')[1]
        })
        if (foundRoute) {
          this.selectedItem = foundRoute.menuSelected
        }

        this.profileActive = params.fullPath.startsWith('/profile')
      },
      deep: true,
      immediate: true
    },
    currentCollaborator(newSelectedCollaborator) {
      this.$store.commit('auth/selectedCollaborator', newSelectedCollaborator.technical_id)
    },
    showCollaborators(bool) {
      if (bool) {
        this.minWidth = this.$refs.selectedCollaborator.clientWidth + 1 + 'px'
      }
    }
  },
  computed: {
    getCollaboratorListActive() {
      return this.$store.getters['auth/getCollaboratorListActive']
    },
    displayCollaboratorInfo() {
      return (
        this.$route.name !== 'StepperFile' &&
        this.$route.name !== 'Shipping' &&
        this.$route.name !== 'CreateRepairFileFinalization'
      )
    },
    displayStoreInfo() {
      return (
        this.$route.name === 'StepperFile' ||
        this.$route.name === 'Shipping' ||
        this.$route.name === 'CreateRepairFileFinalization'
      )
    },
    hideCollaboratorMenu() {
      return this.getCollaboratorListActive.length <= 1
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside)
  },
  created() {
    const connectedUserStoreList = this.$store.getters['auth/getStoreListCollaborator']
    if (connectedUserStoreList.length > 1) {
      this.logo = this.$store.getters['auth/getNetworkLogo']
    } else if (
      connectedUserStoreList.length === 1 &&
      connectedUserStoreList[0].logo_path !== null
    ) {
      this.logo = connectedUserStoreList[0].logo_path
    } else {
      this.logo = null
    }
  },
  methods: {
    checkPermission(permissionsRequired) {
      return this.$store.getters['auth/hasPermission'](permissionsRequired)
    },
    logout() {
      this.loading = true
      this.$store
        .dispatch('auth/logout')
        .then(
          async () => {
            displayToast(this.$t('DISCONNECT.MESSAGE'), 'success')
            this.loading = false
          },
          (error) => {
            this.loading = false
            handleResponseError(error)
          }
        )
        .finally(async () => {
          await this.$router.push({ name: 'Login' })
        })
    },
    selectItem(item) {
      this.selectedItem = item
      this.navigateTo(item)
    },
    navigateTo(item) {
      switch (item) {
        case 'accounts':
          this.$router.push({ name: 'Accounts' })
          break
        case 'profile':
          this.$router.push({ name: 'Profile' })
          break
        case 'folder':
          this.$router.push({ name: 'RepairFileListPage' })
          break
        case 'transporter':
          this.$router.push({ name: 'Transporters' })
          break
        case 'help':
          window.open(this.zendeskUrl, '_blank')
          break
        case 'recyclingReport':
          this.$router.push({ name: 'RecyclingReportPage' })
          break
        default:
          this.$router.push({ name: 'Dashboard' })
      }
    },
    getCurrentCollaborator() {
      return $store.state.currentCollaborator
    },
    getEmailFromAccount() {
      return $store.state.userDetail.email
    },
    repairFileStoreSelected() {
      return this.$store.getters['auth/getRepairFileStoreSelected']?.name
    },
    selectCollaborator(collaborator) {
      this.showCollaborators = false
      this.currentCollaborator = collaborator
    },
    getActiveCollaborator(collaboratorId) {
      return this.currentCollaborator.technical_id === parseInt(collaboratorId)
    },
    handleClickOutside(event) {
      if (this.displayCollaboratorInfo) {
        const selectedCollab = this.$refs.selectedCollaborator
        const collaboratorsList = this.$refs.collaboratorsList

        if (
          !selectedCollab.contains(event.target) &&
          (!collaboratorsList || !collaboratorsList.contains(event.target))
        ) {
          this.showCollaborators = false
        }
      }
    }
  }
}
</script>

<style>
/* remove scroll bar on left navigation bar */
.v-navigation-drawer__content::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px #5d5d5d;
  background-color: #5d5d5d;
}

.v-navigation-drawer__content::-webkit-scrollbar {
  width: 0;
}

.v-navigation-drawer__content::-webkit-scrollbar-thumb {
  -webkit-box-shadow: inset 0 0 6px #424242;
  background-color: #424242;
}

/* remove scroll bar on left navigation bar */

.list-item {
  padding-right: 10px;
}

.list-item .v-field__append-inner > .v-icon {
  content: url('@/assets/icons/navbar/chevron-down.svg');
  font-size: 12px;
  display: flex;
}

.v-field.v-field--variant-underlined .v-field__append-inner {
  padding-top: 29px !important;
}

.v-menu > .v-overlay__content > .v-card,
.v-menu > .v-overlay__content > .v-sheet,
.v-menu > .v-overlay__content > .v-list {
  box-shadow: unset !important;
  border-top: unset !important;
  border-left: unset !important;
  border-bottom: unset !important;
  border-right: unset !important;
  border-radius: 0 0 15px 15px !important;
}

.v-list-item--density-default:not(.v-list-item--nav).v-list-item--one-line:not(
    .v-list-item--active
  ):hover {
  color: #559a1b !important;
}

.v-list-item--density-default:not(.v-list-item--nav).v-list-item--one-line .v-list-item__overlay {
  background-color: unset !important;
  border-radius: unset !important;
}

.v-list-item--density-default.v-list-item--one-line.v-list-item--active {
  color: white !important;
  background-color: #559a1b !important;
}

.line-top,
.line-bottom {
  margin: 0 15% 0 15%;
  border-top: 1px solid white;
}

.v-list-item--active {
  background-color: white !important;
}

.v-navigation-drawer__content {
  border: unset !important;
  background-color: #165039 !important;
  border: solid 1px #165039 !important;
}

.v-list-item__overlay,
.v-list-item--rounded {
  border-radius: 30px !important;
}

.v-list .v-list-item--nav:hover {
  background-color: white !important;
}

.v-navigation-drawer__append {
  background-color: #165039 !important;
  border: solid 1px #165039 !important;
}

.v-list .v-list-item--nav:not(:only-child) {
  margin: 0 0 30% 0 !important;
}

.v-list-item--active {
  background-color: green;
}

.logo-div {
  display: flex;
}

.logo-div {
  display: flex;
  margin-left: 15px;
}

.logo-div .logo {
  min-width: 64px;
  min-height: 64px;
  align-items: center;
  justify-content: center;
  max-width: 600px;
  max-height: 100px;
}

.main {
  background-color: #efefef;
}

.scope .v-list-item__content {
  color: white !important;
}

.v-list-item:hover .v-list-item__content {
  color: #165039 !important;
}

.v-list-item--active .v-list-item__content {
  color: #165039 !important;
}

.selected-collaborator {
  height: 100%;
  display: flex;
  min-width: 250px;
  flex-direction: row;
  align-items: center;
  padding-left: 20px;
  padding-right: 20px;
  background-color: #f8f8f8;
  justify-content: space-between;
  border-left: 1px solid #e0e0e0;
}

.selected-collaborator:hover {
  cursor: pointer;
}

.selected-collaborator:disabled {
  cursor: default;
}

.selected-collaborator-name {
  color: #165039;
  font-weight: bold;
}

.selected-collaborator-email {
  font-size: 13px;
  color: #616161;
}

.selected-collaborator .v-icon {
  margin-top: -5px;
}

.collaborators-list {
  right: 0;
  top: 64px;
  z-index: 1010;
  position: fixed;
  width: fit-content;
}

.collaborators-list ul li {
  list-style: none;
  padding: 10px 20px;
  color: #165039;
  font-weight: bold;
  font-size: 14px;
  display: flex;
  align-items: center;
  background-color: white;
  border-top: 1px solid #e0e0e0;
  border-left: 1px solid #e0e0e0;
  border-right: 1px solid #e0e0e0;
  border-bottom: unset;
  justify-content: space-between;
}

.collaborators-list ul li:last-child {
  border-bottom: 1px solid #e0e0e0;
}

.collaborators-list ul li:hover {
  background-color: #efefef;
  cursor: pointer;
}

.collaborators-list ul li.active {
  background-color: #f8f8f8;
  cursor: pointer;
}

.collaborators-list ul li.active:hover {
  background-color: #efefef;
}

.collaborators-list ul li .v-icon {
  margin-top: -4px;
}

.store-name {
  margin-left: 12px;
}

.v-toolbar {
  box-shadow: 0 0 20px 2px rgba(0, 0, 0, 0.1) !important;
}

.grecaptcha-badge {
  visibility: hidden !important;
}

.specific-icon {
  width: 22px;
  height: 22px;
}

.recycling-report {
  background-image: url('@/assets/images/co2-gas-white.svg');
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
}

.v-list-item--active .recycling-report,
.scope:hover .recycling-report {
  background-image: url('@/assets/images/co2-gas-green.svg');
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
}
</style>
